<template>
    <div>
        <edit-customer-modal :customer="orderContact" :origin="'order'" :on-save-callback="fetchCompanies"></edit-customer-modal>
        <edit-order-items-modal :order="new_order":on-save-callback="fetchOrder"></edit-order-items-modal>
        <div v-if="fetched_order">
            <send-quote-modal :order-id="new_order.id" :payment-terms="new_order.net_terms" :on-save-callback="fetchOrder"></send-quote-modal>
        </div>
        <div class="row justify-content-between mb-0">
            <div class="col-auto d-flex align-items-center">
                <h3 class="mb-0">
                    <span v-if="new_order.order_number">{{ new_order.order_number }}</span>
                    <span v-else>New Order</span>
                </h3>
            </div>
            <div class="col-auto d-flex align-items-center" v-if="!loading">
                <ul class="nav nav-pills border rounded bg-white">
                  <li class="nav-item">
                    <button class="nav-link" :class="new_order.sync_status === 'draft' ? 'active' : ''" aria-current="page" @click="setStatus('draft')">
                        <span class="fa-stack">
                            <i class="fa fa-stack-1x">1</i>
                            <i class="fa fa-circle-thin fa-stack-2x"></i>
                        </span>
                        &nbsp Configure Order &nbsp
                    </button>
                  </li>

                  <li class="nav-item">
                    <button class="nav-link" :class="[new_order.sync_status === 'draft_review' ? 'active' : '', new_order.sync_status === 'draft' ? 'disabled' : '']" @click="setStatus('draft_review')">
                        <span class="fa-stack">
                            <i class="fa fa-stack-1x">2</i>
                            <i class="fa fa-circle-thin fa-stack-2x"></i>
                        </span>
                        &nbsp Review Order &nbsp
                    </button>
    
                  </li>
                  <li class="nav-item">
                    <button class="nav-link" :class="new_order.sync_status === 'draft_confirm' ? 'active' : 'disabled'" aria-current="page" @click="setStatus('draft_confirm')">
                        <span class="fa-stack">
                            <i class="fa fa-stack-1x">3</i>
                            <i class="fa fa-circle-thin fa-stack-2x"></i>
                        </span>
                        &nbsp Complete Order &nbsp
                    </button>
                  </li>
                  
                </ul>
            </div>
            <div class="col-auto d-flex align-items-center">
                <button v-if="!updating" class="btn btn-light mx-2" :class="new_order.items.length != 0 ? '' : 'disabled'"type="button" @click="saveDraft">Save Draft</button>
                <button v-else type="button" class="btn btn-light mx-2" disabled><i class="fa fa-spinner fa-spin"></i>Saving...</button>
               
                <button v-if="new_order.sync_status != 'draft_confirm'" class="btn btn-dark" :class="new_order.items.length != 0 ? '' : 'disabled'" @click="continueOrder" type="button">Save & Continue</button>
                <button v-else class="btn btn-light text-white" style="background-color:#ff7a59;" @click="placeOrder" type="button" :class="orderContact && !orderContact.valid_address ? 'disabled' : ''">Place Order</button>
                <!-- <p v-if="orderContact && !orderContact.valid_address" class="small text-center text-danger"><br>Cannot complete order until company has a valid address</p> -->
            </div>
        </div>
        <hr class="mt-2">
        <div v-if="new_order.sync_status === 'draft'">
            <div class="row justify-content-center">
                <div class="col-md-8">
                    <div class="card">
                        <div class="card-header">
                            <span class="lead">Select Products</span>
                        </div>
                        <div class="card-body">
                            <!-- <div class="row px-3 w-100">
                                Products
                            </div> -->
                            <div class="row justify-content-between">
                             
                                <div class="input-group mb-2">
                                  <input type="text" v-model="pagination.searchparams.search" class="form-control" style="background-color:#fff" placeholder="Search..." @keyup.enter="runSearch" :readonly="loading"/>
                              
                                    <span v-if="!search_params_changed">
                                      <button v-if="!loading" type="button" class="btn btn-outline-secondary  btn-search" @click="runSearch"><i class="fa fa-search"></i></button>
                                    
                                      <button v-else type="button" class="btn btn-outline-secondary btn-search" disabled><i class="fa fa-spinner fa-spin"></i></button>
                                    </span>
                                    <span v-else>
                                      <button type="button" class="btn btn-primary btn-search" @click="search_params_changed = false; runSearch();"><i class="fa fa-search"></i> Apply Updated Filters</button>
                                    </span> &nbsp &nbsp <button class="btn btn-outline-danger btn-reset pull-right" style="border-radius: 0.375rem;" type="button" role="button" @click="resetSearch">Reset</button>
                                     
                                </div>


                           
                            </div>
                            <div class="row">
                                <div class="col">


                                <ul class="nav justify-content-between mb-2">
                                      <li class="nav-item">
                                        <div class="input-group input-group-sm">
                                            <span class="input-group-text">Category</span>
                                            <select v-model="pagination.searchparams.type" class="form-select" style="background-color:#fff" @change="search_params_changed = true" :disabled="loading">
                                              <option value="">All</option>
                                              <option v-for="category in pagination.product_filters.category">
                                                {{ category }}
                                              </option>
                                            </select>
                                          </div>
                                      </li>
                                      <li class="nav-item">
                                        <div class="input-group input-group-sm">
                                            <span class="input-group-text">Style</span>
                                            <select v-model="pagination.searchparams.style" class="form-select" style="background-color:#fff" @change="search_params_changed = true" :disabled="loading">
                                              <option value="">All</option>
                                              <option v-for="style in pagination.product_filters.style">
                                                {{ style }}
                                              </option>
                                            </select>
                                          </div>
                                      </li>
                                      <li class="nav-item">
                                        <div class="input-group input-group-sm">
                                            <span class="input-group-text">Model</span>
                                            <select v-model="pagination.searchparams.model" class="form-select" style="background-color:#fff" @change="search_params_changed = true" :disabled="loading">
                                              <option value="">All</option>
                                              <option v-for="model in pagination.product_filters.model">
                                                {{ model }}
                                              </option>
                                            </select>
                                          </div>
                                      </li>
                                      <li class="nav-item">
                                        <div class="input-group input-group-sm">
                                            <span class="input-group-text">Size</span>
                                            <select v-model="pagination.searchparams.size" class="form-select" style="background-color:#fff" @change="search_params_changed = true" :disabled="loading">
                                                <option value="">All</option>
                                                <option v-for="size in pagination.product_filters.size" :value="size">
                                                    {{ size | sizeDisplay }}
                                                </option>
                                            </select>
                                          </div>
                                      </li>
                                      <li class="nav-item">
                                        <div class="input-group input-group-sm">
                                            <span class="input-group-text">Color</span>
                                            <select v-model="pagination.searchparams.color" class="form-select" style="background-color:#fff" @change="search_params_changed = true" :disabled="loading">
                                              <option value="">All</option>
                                              <option v-for="color in pagination.product_filters.color">
                                                {{ color }}
                                              </option>
                                            </select>
                                          </div>
                                      </li>
                                      <li class="nav-item px-1 pt-2 mb-0">
                                          <div class="form-check">
                                            <input v-model="pagination.searchparams.in_stock_only" class="form-check-input" type="checkbox" true-value="true" false-value="" id="flexCheckIndeterminate" @change="search_params_changed = true" :disabled="loading">
                                            <label class="form-check-label" for="flexCheckIndeterminate">
                                              In Stock Only
                                            </label>
                                          </div>
                                       
                                      </li>
                                    </ul>
                                </div>
                            </div>
                            <div v-if="!product_selected">
                                <div class="order-wrapper mt-2" v-if="pagination.data.length > 0">
                                    <div v-if="loading" class="d-flex justify-content-center">
                                        <div class="spinner-border text-success" role="status">
                                            <span class="visually-hidden">Loading...</span>
                                        </div>
                                    </div>
                                    <div v-else class="order-table px-0 mx-0 my-0" >
                                        <div class="order-tr order-th sticky-top">
                                            <div class="order-td order-img-col"></div>
                                            <div class="order-td order-sku-col">SKU</div>
                                            <div class="order-td order-name-col text-center">Description</div>
                                            <div class="order-td order-price-col">Wholesale</div>
                                            <div class="order-td order-price-col">Retail MAP</div>
                                            <div class="order-td order-quantity-col">QOH</div>
                                            
                                            <!-- <div class="order-td">Quantity</div>
                                            <div class="order-td">Total</div> -->
                                        </div>
                                        <div class="order-tr" v-for="product in products" :key="product.id" :style="product.quantity_orderable > 0 ? 'cursor: pointer;' : 'cursor: pointer;'" @click="setActiveProduct(product)">
                                            
                                            <div class="order-td position-relative order-img-col"><img class="img-thumbnail" :alt="product.name" :src="product.image_url" crossorigin="anonymous" @error="product.image_url='/imgs/doomswell-placeholder.png'"/> 
                                            <span v-if="product.quantity_orderable === 0" class="position-absolute bottom-0 start-50 translate-middle badge rounded-pill bg-danger">
                                                out of stock
                                            </span>
                                            <span v-if="product.quantity_available === 0 && product.quantity_incoming > 0" class="position-absolute bottom-0 start-50 translate-middle badge rounded-pill bg-success">
                                                preorder
                                            </span>
                                        </div>
                                            <div class="order-td order-sku-col">{{ product.sku }}</div>
                                            <div class="order-td order-name-col">{{ product.name }}</div> 
                                            <div class="order-td order-price-col fw-bold">{{ product.sale_price | currency }}</div>
                                            <div class="order-td order-price-col">{{ product.retail_price | currency }}</div>
                                            <div class="order-td order-quantity-col">{{ product.quantity_on_hand }}</div>
                                        </div>
                                    </div>
                                    
                                </div>
                                <div v-else v-show="!loading" class="row justify-content-center">
                                    <div class="row justify-content-center pt-3 pb-2">
                                      No products matching search criteria found
                                  </div>
                                      
                                  <div class="row justify-content-center col-auto">
                                      <button class="btn btn-outline-danger btn-reset pull-right" style="border-radius: 0.375rem;" type="button" role="button" @click="resetSearch">Reset</button>
                                  </div>
                                </div>
                            </div>
                            <div v-else class="row mb-2">
                                <div class="col-12">
                                    <hr class="mt-3">
                                    <div id="selectedProduct" class="form-select form-select-lg mt-4" @click="product_selected = false" style="cursor: pointer;">{{ selected_product.name }}</div>
                                </div>
                            </div>
                            <!-- </Transition> -->
                                <div v-show="selected_product.length != 0" class="order-item-config">
                                    <div class="row justify-content-start py-2">
                                        <div class="col-auto ">Product Details</div><hr  class="col" style="margin-top:12px;margin-right:12px;">
                                    </div>
                                    <div class="row justify-content-start">
                                        <div class="col-md-2" v-show="selected_product.type">
                                            <label for="selectedProductCategory" class="form-label text-muted mb-0"><small>Category</small></label>
                                            <input type="text" readonly class="form-control-plaintext" id="selectedProductCategory" :value="selected_product.type">
                                        </div>
                                        <div class="col-md-2" v-show="selected_product.model">
                                            <label for="selectedProductModel" class="form-label text-muted mb-0"><small>Model</small></label>
                                            <input type="text" readonly class="form-control-plaintext" id="selectedProductModel" :value="selected_product.model">
                                        </div>
                                        <div class="col-md-2" v-show="selected_product.size">
                                            <label for="selectedProductSize" class="form-label text-muted mb-0"><small>Size</small></label>
                                            <input type="text" readonly class="form-control-plaintext" id="selectedProductSize" :value="selected_product.size">
                                        </div>
                                        <div class="col-md-2" v-show="selected_product.style">
                                            <label for="selectedProductStyle" class="form-label text-muted mb-0"><small>Style</small></label>
                                            <input type="text" readonly class="form-control-plaintext" id="selectedProductStyle" :value="selected_product.style">
                                        </div>
                                        <div class="col-md-2" v-show="selected_product.color">
                                            <label for="selectedProductColor" class="form-label text-muted mb-0"><small>Color</small></label>
                                            <input type="text" readonly class="form-control-plaintext" id="selectedProductColor" :value="selected_product.color">
                                        </div>
                                    </div>

                                    <div class="row justify-content-start py-2">
                                        <div class="col-auto ">Order Quantity</div>
                                        <hr  class="col" style="margin-top:12px;margin-right:12px;">
                                    </div>
                                    <div class="row d-flex justify-content-center g-1 px-3 py-2">
                                        <div class="card text-dark " style="background-color:#e3eeff;">
                                            <div class="card-body px-0">
                                                <div class="row d-flex justify-content-evenly">
                                                <div v-if="!new_order.multi_ship"class="col-md-2 text-center" style="max-width:100px;">
                                                    <label for="shipOneQuantity" class="form-label text-muted mb-0"><small>Quantity</small></label>
                                                    <input v-model="new_item.ship_one.quantity" type="number" class="form-control text-center" id="shipOneQuantity" name="ship1" min="0" :max="maxItemQuantity">
                                                </div>
                                                <div v-if="new_order.multi_ship" class="col-md-2 text-center" style="max-width:100px;">
                                                    <label for="shipOneQuantity" class="form-label text-muted mb-0"><small>Ship 1</small></label>
                                                    <input v-model="new_item.ship_one.quantity" type="number" class="form-control text-center" id="shipOneQuantity" name="ship1" min="0" :max="maxShipOneItemQuantity">
                                                </div>
                                                <div v-if="new_order.multi_ship" class="col-md-2 text-center" style="max-width:100px;">
                                                    <label for="shipTwoQuantity" class="form-label text-muted mb-0"><small>Ship 2</small></label>
                                                    <input v-model="new_item.ship_two.quantity" type="number" class="form-control text-center" id="shipTwoQuantity" name="ship2" min="0" :max="maxShipTwoItemQuantity">
                                                </div>
                                                <div v-if="new_order.multi_ship" class="col-md-2 text-center"  style="max-width:125px;">
                                                    <label for="totalQuantity" class="form-label text-muted mb-0"><small>Total Quantity</small></label>
                                                    <input type="text" readonly class="form-control-plaintext text-center" id="totalQuantity" :value="new_item.total_quantity">
                                                </div>
                                                <div class="col-md-2 text-center" style="max-width:100px;">
                                                    <label for="selectedProductWholesale" class="form-label text-muted mb-0"><small>Wholesale</small></label>
                                                    <input v-if="!new_item.margin_override" type="text" readonly class="form-control-plaintext text-center" id="selectedProductWholesale" :value="selected_product.sale_price|currency">
                                                    <input v-else v-model="new_item.unit_price" type="number" step="0.01" class="form-control text-center" id="selectedProductWholesale" :placeholder="selected_product.sale_price|currency">
                                                </div>
                                                <!-- <div class="col-md-2 text-center" style="max-width:100px;">
                                                    <label for="selectedProductWholesaleMargin" class="form-label text-muted mb-0"><small>Margin</small></label>
                                                    <input type="text" readonly class="form-control-plaintext text-center" id="selectedProductWholesaleMargin" value="45%">
                                                </div> -->
                                                <div class="col-md-2 text-center" style="max-width:100px;">
                                                    <label for="selectedProductRetail" class="form-label text-muted mb-0"><small>MAP</small></label>
                                                    <input type="text" readonly class="form-control-plaintext text-center" id="selectedProductRetail" :value="selected_product.retail_price|currency">
                                                </div>
                                                <div class="col-md-2 text-center" style="max-width:100px;">
                                                    <label for="totalCost" class="form-label text-muted mb-0"><small class="fw-bold">Item Total</small></label>
                                                    <input type="text" class="form-control-plaintext text-center fw-bold" id="totalCost" :value="new_item.total_cost|currency">
                                                </div>
                                                <div class="row d-flex justify-content-between align-items-end mt-3">
                                                    <!-- <div class="col-1">
                                                    </div> -->
                                                    <div class="col-md-auto" :class="new_order.multi_ship ? '' : 'offset-sm-1 px-1 mx-5'">
                                                        <p  class="text-muted small mb-1">Available: {{ this.selected_product.quantity_available }}</p>
                                                        <p class="text-muted small mb-0">Incoming: {{ this.selected_product.quantity_incoming }}</p>
                                                    </div>
                                                    <div class="col-md-auto">
                                                        <p v-if="!new_item.preorder" class="text-muted text-start small mb-1">
                                                            Allow Preorder &nbsp <i type="button" role="button" class="fa fa-toggle-off" aria-hidden="true" @click="togglePreorder(new_item)"></i>
                                                        </p>
                                                        <p v-else class="text-muted text-start small mb-1">
                                                            Allow Preorder &nbsp <i type="button" role="button" class="fa fa-toggle-on text-success" aria-hidden="true" @click="togglePreorder(new_item)"></i>
                                                        </p>
                                                        <p v-if="!new_item.margin_override" class="text-muted text-end small mb-1"  v-tooltip:bottom="'Set Custom Price'">
                                                            Custom Price &nbsp <i type="button" role="button" class="fa fa-toggle-off" aria-hidden="true" @click="new_item.margin_override = !new_item.margin_override"></i>
                                                        </p>
                                                        <p v-else class="text-muted text-end small mb-1"  v-tooltip:bottom="'Restore Default Price (On Save)'">
                                                            Custom Price &nbsp <i type="button" role="button" class="fa fa-toggle-on text-success" aria-hidden="true" @click="new_item.margin_override = !new_item.margin_override"></i>
                                                        </p>
                                                    </div>
                                                    <div class="col-md-auto">
                                                        <button class="btn btn-light float-right" type="button" @click="cancelOrderItem">Cancel</button>
                                                        <button :disabled="new_item.total_cost == 0" class="btn btn-primary float-right" type="button" @click="addItemToOrder">Add To Order</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                        <div class="card" :class="contact_warning ? 'border-danger' : ''" style="font-size:1rem;">
                            <div class="card-header">
                                <span class="lead">Order Options</span>
                            </div>
                            <div class="card-body">
                                <div class="row mt-2">
                                    <div class="col w-100">
                                        <label for="orderCompany" class="form-label" :class="contact_warning ? 'text-danger' : ''">Company</label>
                                        <v-select
                                            v-model="new_order.contact_id"
                                            id="orderCompany"
                                            label="company_label"
                                            :options="contacts"
                                            :reduce="company_name => company_name.id"
                                            :class="contact_warning ? 'border-danger' : ''"
                                        />
                                        <div v-if="orderContact && orderContact.valid_address != true" class="alert alert-warning mt-2 text-center" role="alert">
                                            The selected company has an incomplete shipping address. Address update will be required before completing.
                                            <br>
                                            <a @click="showEditCustomerModal" type="button" role="button" class="btn btn-sm btn-light text-secondary border-secondary mt-2"><i class="fa fa-pencil"></i>&nbsp Update {{ orderContact.company_name }}</a>

                                        </div>
                                        
                                        <!-- <label for="orderCompany" class="form-label" :class="contact_warning ? 'text-danger' : ''">Company</label>
                                        <select v-model="new_order.contact_id" id="orderCompany" class="form-select" :class="contact_warning ? 'border-danger' : ''"aria-label="Company selection">
                                            <option v-for="contact in contacts" :key="contact.id" :value="contact.id">
                                              {{ contact.company_name }}
                                            </option>
                                        </select> -->
                                       <!--  <label for="orderCompany" class="form-label" :class="contact_warning ? 'text-danger' : ''">Company</label>
                                        <input class="form-control" list="datalistOptions" id="orderCompany" placeholder="Type to search...">
                                        <datalist v-model="new_order.contact_id" id="datalistOptions" :class="contact_warning ? 'border-danger' : ''"aria-label="Company selection">
                                        
                                            <option v-for="contact in contacts" :key="contact.id" :value="contact.id">
                                              {{ contact.company_name }}
                                            </option>
                                        </datalist> -->
                                    </div>
                                </div>
                                <hr>
                                <div class="row mt-2">
                                    <div class="col w-100">
                                        <span v-if="!new_order.multi_ship">Split Shipments: &nbsp <i type="button" role="button" class="fa fa-toggle-off" aria-hidden="true" @click="toggleSplitShipments"></i></span>
                                        <span v-else>Split Shipments: &nbsp <i type="button" role="button" class="fa fa-toggle-on text-success" aria-hidden="true" @click="toggleSplitShipments"></i></span>
                                    </div>
                                </div>

                                <div class="row pt-2 mt-2">
                                    <div class="col w-100">
                                        <label for="shipOne" class="form-label">Ship Date</label>
                                        <input type="date" class="form-control" id="shipOne" v-model="new_order.ship_one_date" :min="min_ship_date" :max="max_ship_date">
                                    </div>
                                </div>
                                <div class="row pt-2 mt-2" v-if="new_order.multi_ship">
                                    <div class="col w-100">
                                        <label for="shipTwo" class="form-label">Ship Date Two</label>
                                        <input type="date" class="form-control" id="shipTwo" v-model="new_order.ship_two_date" :min="min_ship_date" :max="max_ship_date">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card w-100 mt-3">
                            <div class="card-header">
                                <span class="lead">Order Details</span>
                                <button v-if="new_order.items.length != 0" :class="!new_order.order_number ? 'disabled' : ''" type="button" class="btn btn-sm btn-light pull-right" @click="editOrderItems(new_order)">
                                    <span v-if="!new_order.order_number">Save Draft to Enable Edit</span>
                                    <span v-else>Edit</span>
                                </button>
                            </div>
                            <div class="card-body" v-if="new_order.items.length != 0">

                                <div class="line-item-table px-0 mx-0 my-0" >

                                        <div class="line-item-tr" v-for="item in new_order.items" :key="item.id">
                                            
                                            <div class="line-item-td line-item-img-col">
                                                <div class="position-relative">
                                                    <img class="img-thumbnail" :alt="item.name" :src="item.image_url" crossorigin="anonymous" @error="item.image_url='/imgs/doomswell-placeholder.png'"/>
                                                    <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                                                        {{ item.total_quantity }}
                                                        <!-- <span class="visually-hidden">unread messages</span> -->
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="line-item-td line-item-meta-col pl-2">

                                                            <span class="fw-bold">{{ item.name }}</span>
                                                            &nbsp<span v-if="item.preorder" class="badge bg-success"><small>preorder</small></span>
                                            </div>
                                            <div class="line-item-td line-item-cost-col">
                                                <span class="fw-bold">{{ item.total_cost | currency }}</span>
                                            </div> 
                                        </div>
                                        <div class="line-item-tr">
                                            <div class="line-item-td justify-content-start" style="max-width:75px;">
                                                <h3>Total</h3>
                                            </div>
                                            <div class="line-item-td justify-content-end">
                                                <span class="text-muted"><s>{{ (new_order.total_cost / retailDenominator) | currency }}</s>&nbsp</span>
                                                <h3>{{ new_order.total_cost | currency }}</h3>
                                            </div>
                                        </div>
                                    </div>
                            </div>
                            <div class="card-body" v-else>
                                Click item to add to order
                            </div>
                        </div>
                </div>
            </div>
        </div>
        <div v-if="new_order.sync_status === 'draft_review'">
            
            <div class="row justify-content-center" v-if="!loading">
                <div class="col-md-12">
                    <div class="card mb-2" >
                        <div class="card-header">
                            <span class="lead">Order Details</span>
                                <span class="pull-right">
                                    <button v-if="!toggle_contact_edit" type="button" class="btn btn-sm btn-light" @click="edit_contact(new_order.contact_id)">Change Company</button>
                                    <button v-else type="button" class="btn btn-sm btn-light" @click="cancel_contact_edit">Cancel</button>
                                    <button v-if="!toggle_contact_edit" type="button" role="button" @click="showEditCustomerModal"  class="btn btn-sm btn-light">Edit Company</button>
                                </span>
                                
                                
                          
                                
                        
                        </div>
                        <div class="card-body" style="font-size:.9rem;">
                            <div class="row justify-content-center" v-if="toggle_contact_edit">
                                <div class="col-md-6">
                                    <label for="orderCompany" class="form-label text-start" :class="contact_warning ? 'text-danger' : ''">Select Company</label>
                                    <v-select
                                        v-model="new_order.contact_id"
                                        id="orderCompany"
                                        label="company_label"
                                        :options="contacts"
                                        :reduce="company_name => company_name.id"
                                        :class="contact_warning ? 'border-danger' : ''"
                                    />
                                    <button type="button" class="btn btn-sm btn-light float-end my-2 ml-1" @click="cancel_contact_edit">Cancel</button>
                                    <button type="button" class="btn btn-sm btn-light text-white float-end my-2" style="background-color:#ff7a59;" @click="toggle_contact_edit = false; saveDraft();">Select Company</button>
                                    
                                </div>
                                <hr>
                            </div>
                            <div v-if="orderContact" class="row">
                                <div class="col-md-3">
                                    <div class="row mb-0">
                                        <label class="col-sm-auto col-form-label fw-bold" for="contactName">Buyer:</label>
                                        <div class="col-sm-auto">
                                            <span v-if="orderContact.contact_name" id="contactName" class="form-control-plaintext">{{ orderContact.contact_name }}</span>
                                            <span id="company_name" class="form-control-plaintext">{{ orderContact.company_name }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="row mb-0">
                                        <label class="col-sm-3 col-form-label fw-bold" for="email">Email:</label>
                                        <div class="col-sm-9">
                                            <span id="email" class="form-control-plaintext">{{ orderContact.email }}</span>
                                        </div>
                                    </div>
                                    <div class="row mb-0">
                                        <label class="col-sm-3 col-form-label fw-bold" for="email">Phone:</label>
                                        <div class="col-sm-9">
                                            <span id="email" class="form-control-plaintext">{{ orderContact.phone }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="row mb-0">
                                        <label class="col-sm-3 col-form-label fw-bold" for="orderCity" :class="!orderContact.city ? 'text-danger' : ''">City:</label>
                                        <div class="col-sm-9">
                                            <span v-if="orderContact.city" id="orderCity" class="form-control-plaintext">{{ orderContact.city }}</span>
                                            <a v-if="!orderContact.city" @click="showEditCustomerModal" type="button" role="button" class="btn btn-sm btn-outline-danger">Update</a>
                                        </div>
                                    </div>
                                    <div class="row mb-0">
                                        <label class="col-sm-3 col-form-label fw-bold" for="orderState" :class="!orderContact.state ? 'text-danger' : ''">State:</label>
                                        <div class="col-sm-9">
                                            <span v-if="orderContact.state" id="orderState" class="form-control-plaintext">{{ orderContact.state }}</span>
                                            <a v-if="!orderContact.state" @click="showEditCustomerModal" type="button" role="button" class="btn btn-sm btn-outline-danger">Update</a>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="row mb-0">
                                        <label class="col-sm-4 col-form-label fw-bold" for="email">Rep:</label>
                                        <div class="col-sm-8">
                                            <span id="email" class="form-control-plaintext">{{ user.name }}</span>
                                        </div>
                                    </div>
                                    <div class="row mb-0">
                                        <label class="col-sm-4 col-form-label fw-bold" for="email">Order Date:</label>
                                        <div class="col-sm-8">
                                            <span id="email" class="form-control-plaintext">{{ todaysDate }}</span>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div v-if="orderContact && !orderContact.valid_address" class="row">
                                <div class="col-auto">
                                    <div class="alert alert-warning text-center">
                                        The selected company has an incomplete shipping address. Address update will be required before completing.
                                        <br>
                                        <a @click="showEditCustomerModal" type="button" role="button" class="btn btn-sm btn-light text-secondary border-secondary mt-2"><i class="fa fa-pencil"></i>&nbsp Update {{ orderContact.company_name }} Shipping Address</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row justify-content-center" v-if="!loading">
                <div class="col-md-9">
                    <div class="card">
                        <div class="card-header">
                            <span class="lead">Order Items</span><button type="button" class="btn btn-sm btn-light pull-right" @click="editOrderItems(new_order)">Edit</button>
                        </div>
                        <div class="confirm-wrapper">
                            <div class="confirm-table px-0 mx-0 my-0">
                                <div class="confirm-tr confirm-th">
                                    <div class="confirm-td confirm-img-col"></div>
                                    <div class="confirm-td text-center">SKU</div>
                                    <div class="confirm-td text-center">Description</div>
                                    <!-- <div class="confirm-td">Volume Discount Price</div> -->
                                    <div v-if="new_order.multi_ship" class="confirm-td confirm-qty-col">Ship 1</div>
                                    <div v-if="new_order.multi_ship" class="confirm-td confirm-qty-col">Ship 2</div>
                                    <div class="confirm-td confirm-total-qty-col">Order Qty</div>
                                    <div class="confirm-td confirm-price-col">Wholesale</div>
                                    <!-- <div class="confirm-td text-center">Wholesale Margin</div> -->
                                    <!-- <div class="confirm-td">Wholesale Total</div> -->
                                    <div class="confirm-td confirm-price-col">Retail MAP</div>
                                    <div class="confirm-td confirm-total-price-col">Item Total</div>
                                </div>
                                <div class="confirm-tr" v-for="item in new_order.items">
                                    <div class="confirm-td confirm-img-col">
                                        <div class="position-relative">
                                            <img class="img-thumbnail" :alt="item.name" :src="item.image_url" crossorigin="anonymous" @error="item.image_url='/imgs/doomswell-placeholder.png'"/>
                                            <span v-if="item.preorder" class="position-absolute bottom-0 start-50 translate-middle badge rounded-pill bg-success" style="opacity:0.6 !important;">
                                                <small>preorder</small>
                                                <span class="visually-hidden">preorder</span>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="confirm-td text-center">{{ item.sku }}</div>
                                    <div class="confirm-td text-center">{{ item.name }}</div>
                                    <!-- <div class="confirm-td">Volume Discount Price</div> -->
                                    <div v-if="new_order.multi_ship" class="confirm-td confirm-qty-col" style="background-color:#7ed7f7;">{{ item.ship_one.quantity }}</div>
                                    <div v-if="new_order.multi_ship" class="confirm-td confirm-qty-col"  style="background-color:#a3cde4;">{{ item.ship_two.quantity }}</div>
                                    <div class="confirm-td confirm-total-qty-col" style="background-color:#9bbed0;">{{ item.total_quantity }}</div>
                                    <div class="confirm-td confirm-price-col" style="background-color:#d8d8d8;">{{ item.unit_price | currency }} <i v-if="item.margin_override" class="fa fa-exclamation-circle px-1 text-muted" aria-hidden="true" v-tooltip:right="'Custom Price'"></i></div>
                                    <!-- <div class="confirm-td text-center">Wholesale Margin</div> -->
                                    <!-- <div class="confirm-td">Wholesale Total</div> -->
                                    <div class="confirm-td confirm-price-col" style="background-color:#e1f2d7;">{{ item.retail_price | currency}}</div>
                                    <div class="confirm-td confirm-total-price-col">{{ item.total_cost | currency }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-3">
                    
                        <div class="card px-0">
                            <div class="card-header">
                                <span class="lead">Payment Details</span>
                                <button v-if="fetched_order" type="button" class="btn btn-sm btn-dark pull-right" @click="sendQuote">Email Quote</button>
                            </div>
                            <div class="card-body py-0" style="padding:12px;">
                                <div class="row mb-0 px-2 py-2"> <!-- style="background-color:#bce7ff;"> -->
                                    <label class="col-sm-5 col-form-label fw-bold" for="orderTotal">Order Total</label>
                                    <div class="col-sm-7">
                                        <span id="orderTotal" class="form-control-plaintext">{{ new_order.total_cost | currency }} <span class="text-muted"><s>{{ retailTotalCost | currency }}</s>&nbsp</span></span>
                                    </div>
                                </div>
                                <div class="row mb-0 pl-2 pr-0 py-2 border border-warning" style="border-color:yellow;">
                                    <label class="col-sm-5 col-form-label fw-bold" for="marginDiscount">Custom Margin</label>
                                    <div class="col-sm-7">
                                        <div v-if="new_order.discount_percent == 0">
                                            <button class="btn btn-outline-dark" type="button" id="marginDiscountAddon" @click="new_order.discount_percent = 40">Edit Margin</button>
                                        </div>
                                        <div v-else class="input-group mb-3">
                                            <input type="number" id="marginDiscount" v-model="new_order.discount_percent" class="form-control" min="1" max="100">
                                            <button class="btn btn-outline-success px-2" type="button" id="marginDiscountAddon1" @click="saveDraft"><small>Apply</small></button>
                                            <button class="btn btn-outline-danger px-2" type="button" id="marginDiscountAddon2" @click="new_order.discount_percent = 0;saveDraft();"><i class="fa fa-times"></i></button>
                                        </div>
                                        
                                    </div>
                                    <span class="text-muted">Click red X to reload SkuVault prices. Beta feature, use with caution.</span>
                                </div>
                                <div class="row mb-0 px-2 py-2"> <!-- style="background-color:#63b2be;"> -->
                                    <label class="col-sm-5 col-form-label fw-bold" for="terms">Terms</label>
                                    <div class="col-sm-7">
                                        <!-- <span id="terms" class="form-control-plaintext">{{ paymentTerms }}</span> -->
                                        <select id="terms" v-model="new_order.net_terms" class="form-select" style="background-color:#fff" :disabled="loading">
                                              <option value="Net 30">Net 30</option>
                                              <option value="Net 45">Net 45</option>
                                              <option value="Net 60">Net 60</option>
                                              <option value="Net 90">Net 90</option>
                                            </select>
                                    </div>
                                </div>
                                <div class="row mb-0 px-2 py-2"><!--  style="background-color:#ffefb0;"> -->
                                    <label class="col-sm-5 col-form-label fw-bold" for="sd1">Ship Date One</label>
                                    <div class="col-sm-7">
                                        <span id="sd1" class="form-control-plaintext">{{ new_order.ship_one_date | moment }}</span>
                                    </div>
                                </div>
                                <div v-if="new_order.ship_two_date" class="row mb-0 px-2 py-2"><!--  style="background-color:#ffdfb8;"> -->
                                    <label class="col-sm-5 col-form-label fw-bold" for="sd2">Ship Date Two</label>
                                    <div class="col-sm-7">
                                        <span id="sd2" class="form-control-plaintext">{{ new_order.ship_two_date | moment}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                  
                </div>
            </div>
        </div>
        <div v-if="new_order.sync_status === 'draft_confirm'">
                        <div class="row justify-content-center" v-if="!loading">
                <div class="col-md-12">
                    <div class="card mb-2" >
                        <div class="card-header">
                            <span class="lead">Order Details</span>
                        </div>
                        <div class="card-body" style="font-size:.9rem;">
                            <div class="row" v-if="orderContact">
                                <div class="col-md-3">
                                    <div class="row mb-0">
                                        <label class="col-sm-auto col-form-label fw-bold" for="contactName">Buyer:</label>
                                        <div class="col-sm-auto">
                                            <span v-if="orderContact.contact_name" id="contactName" class="form-control-plaintext">{{ orderContact.contact_name }}</span>
                                            <span id="company_name" class="form-control-plaintext">{{ orderContact.company_name }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="row mb-0">
                                        <label class="col-sm-3 col-form-label fw-bold" for="email">Email:</label>
                                        <div class="col-sm-9">
                                            <span id="email" class="form-control-plaintext">{{ orderContact.email }}</span>
                                        </div>
                                    </div>
                                    <div class="row mb-0">
                                        <label class="col-sm-3 col-form-label fw-bold" for="email">Phone:</label>
                                        <div class="col-sm-9">
                                            <span id="email" class="form-control-plaintext">{{ orderContact.phone }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="row mb-0">
                                        <label class="col-sm-3 col-form-label fw-bold" for="orderCity" :class="!orderContact.city ? 'text-danger' : ''">City:</label>
                                        <div class="col-sm-9">
                                            <span v-if="orderContact.city" id="orderCity" class="form-control-plaintext">{{ orderContact.city }}</span>
                                            <a v-if="!orderContact.city" @click="showEditCustomerModal" type="button" role="button" class="btn btn-sm btn-outline-danger">Update</a>
                                        </div>
                                    </div>
                                    <div class="row mb-0">
                                        <label class="col-sm-3 col-form-label fw-bold" for="orderState" :class="!orderContact.state ? 'text-danger' : ''">State:</label>
                                        <div class="col-sm-9">
                                            <span v-if="orderContact.state" id="orderState" class="form-control-plaintext">{{ orderContact.state }}</span>
                                            <a v-if="!orderContact.state" @click="showEditCustomerModal" type="button" role="button" class="btn btn-sm btn-outline-danger">Update</a>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="row mb-0">
                                        <label class="col-sm-4 col-form-label fw-bold" for="email">Rep:</label>
                                        <div class="col-sm-8">
                                            <span id="email" class="form-control-plaintext">{{ user.name }}</span>
                                        </div>
                                    </div>
                                    <div class="row mb-0">
                                        <label class="col-sm-4 col-form-label fw-bold" for="email">Order Date:</label>
                                        <div class="col-sm-8">
                                            <span id="email" class="form-control-plaintext">{{ todaysDate }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="orderContact && !orderContact.valid_address" class="row">
                                <div class="col-auto">
                                    <div class="alert alert-danger text-center">
                                        The selected company has an incomplete shipping address.
                                        <br>
                                        <strong>You must add a shipping address or select a different company to place this order.</strong>
                                        <br>
                                        <a @click="showEditCustomerModal" type="button" role="button" class="btn btn-sm btn-light text-secondary border-secondary mt-2"><i class="fa fa-pencil"></i>&nbsp Update {{ orderContact.company_name }} Shipping Address</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row justify-content-center" v-if="!loading">
                <div class="col-md-8">
                    <div class="card mb-2">
                        <div class="card-header"><span class="lead">Shipment One &mdash; {{ new_order.ship_one_date | moment }}</span></div>
                        <div class="confirm-item-table px-0 mx-0 my-0" >
                            <div class="confirm-item-tr" v-for="item in new_order.items" :key="item.id" v-if="item.ship_one.quantity > 0">
                                <div class="confirm-item-td confirm-item-img-col">
                                    <div class="position-relative">
                                        <img class="img-thumbnail" :alt="item.name" :src="item.image_url" crossorigin="anonymous" @error="item.image_url='/imgs/doomswell-placeholder.png'"/>
                                        <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                                            {{ item.ship_one.quantity }}
                                            <span class="visually-hidden">quantity</span>
                                        </span>
                                    </div>
                                </div>
                                <div class="confirm-item-td pl-3">
                                    <div class="line-item-child-table">
                                        <div class="line-item-child-tr confirm-item-meta-col">
                                            <div class="line-item-child-td">{{ item.name }} &nbsp <span v-if="item.preorder" class="badge bg-success" style="font-size:.8rem;font-weight:500;"><small>preorder</small></span></div>
                                        </div>
                                        <div class="line-item-child-tr">
                                            <div class="line-item-child-td confirm-item-cost-col">
                                                <span class="">{{ item.ship_one.cost | currency }}</span>&nbsp<span class="text-muted align-top text-decoration-line-through" style="font-size:0.8rem;font-weight:500;">{{ (item.ship_one.cost / retailDenominator) | currency }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                
                    <div class="card" v-if="new_order.multi_ship">
                        <div class="card-header"><span class="lead">Shipment Two &mdash; {{ new_order.ship_two_date | moment }}</span></div>
                        <div class="confirm-item-table px-0 mx-0 my-0" >
                            <div class="confirm-item-tr" v-for="item in new_order.items" :key="item.id" v-if="item.ship_two.quantity > 0">
                                <div class="confirm-item-td confirm-item-img-col">
                                    <div class="position-relative">
                                        <img class="img-thumbnail" :alt="item.name" :src="item.image_url" crossorigin="anonymous" @error="item.image_url='/imgs/doomswell-placeholder.png'"/>
                                        <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                                            {{ item.ship_two.quantity }}
                                            <span class="visually-hidden">quantity</span>
                                        </span>
                                    </div>
                                </div>
                                <div class="confirm-item-td pl-3">
                                    <div class="line-item-child-table">
                                        <div class="line-item-child-tr confirm-item-meta-col">
                                            <div class="line-item-child-td">{{ item.name }} &nbsp <span v-if="item.preorder" class="badge bg-success" style="font-size:.8rem;font-weight:500;"><small>preorder</small></span></div>
                                        </div>
                                        <div class="line-item-child-tr">
                                            <div class="line-item-child-td confirm-item-cost-col">
                                                <span class="">{{ item.ship_two.cost | currency }}</span>&nbsp<span class="text-muted align-top text-decoration-line-through" style="font-size:0.8rem;font-weight:500;">{{ (item.ship_two.cost / retailDenominator) | currency }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="row mb-3">
                        <div class="card px-0">
                            <div class="card-header">
                                <span class="lead">Payment Details</span>
                                <button v-if="fetched_order" type="button" class="btn btn-sm btn-dark pull-right" @click="sendQuote">Email Quote</button>
                            </div>
                            <div class="card-body py-0" style="padding:12px;font-size:1.1em;">
                                <div class="row mb-0 px-2 pt-2">
                                    <label class="col-sm-5 col-form-label fw-bold" for="marginDiscount">Order Total</label>
                                    <div class="col-sm-7">
                                        <span id="marginDiscount" class="form-control-plaintext">{{ new_order.total_cost | currency }} &nbsp<span class="text-muted align-top text-decoration-line-through" style="font-size:0.8rem;font-weight:500;">{{ retailTotalCost | currency }}</span></span>
                                    </div>
                                </div>
                                <div class="row mb-0 px-2">
                                    <label class="col-sm-5 col-form-label fw-bold" for="marginDiscount">Margin Discount</label>
                                    <div class="col-sm-7">
                                        <span id="marginDiscount" class="form-control-plaintext"><span v-if="new_order.discount_percent == 0">Default</span><span v-else>{{ new_order.discount_percent }}%</span></span>
                                    </div>
                                </div>
                                <div class="row mb-0 px-2">
                                    <label class="col-sm-5 col-form-label fw-bold" for="marginDiscount">Payment Terms</label>
                                    <div class="col-sm-7">
                                        <!-- <span id="marginDiscount" class="form-control-plaintext">{{ paymentTerms }}</span> -->
                                            <select v-model="new_order.net_terms" class="form-select" style="background-color:#fff" :disabled="loading">
                                              <option value="Net 30">Net 30</option>
                                              <option value="Net 45">Net 45</option>
                                              <option value="Net 60">Net 60</option>
                                              <option value="Net 90">Net 90</option>
                                            </select>

                                    </div>
                                </div>
                                <div class="row mb-0 px-2">
                                    <label class="col-sm-5 col-form-label fw-bold" for="marginDiscount">Ship Date One</label>
                                    <div class="col-sm-7">
                                        <span id="marginDiscount" class="form-control-plaintext">{{ new_order.ship_one_date | moment }}</span>
                                    </div>
                                </div>
                                <div class="row mb-0 px-2" v-if="new_order.ship_two_date">
                                    <label class="col-sm-5 col-form-label fw-bold" for="marginDiscount">Ship Date Two</label>
                                    <div class="col-sm-7">
                                        <span id="marginDiscount" class="form-control-plaintext">{{ new_order.ship_two_date | moment}}</span>
                                    </div>
                                </div>
                                <div class="row justify-content-center px-3 py-3">
                                    <button v-if="orderContact && orderContact.valid_address" type="button" role="button" class="btn btn-lg btn-light text-white" style="background-color:#ff7a59;" @click="placeOrder">Place Order</button>
                                    <button v-else type="button" role="button" class="btn btn-lg btn-light text-white" style="background-color:#ff7a59;" @click="placeOrder" disabled>Place Order</button>
                                    <span v-if="orderContact && !orderContact.valid_address" class="small text-center text-danger">Cannot complete order until company has a valid address</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="css" scoped>
    .v-enter-active,
    .v-leave-active {
      transition: opacity 0.5s ease;
    }

    .v-enter-from,
    .v-leave-to {
      opacity: 0;
    }

    .btn-light {
    background-color: white;
    /*border-color: #49545a;*/
    border: 1px solid #b0b9bf;
  }

  .btn-light:hover, .btn-light:active, .btn-light:focus {
    background-color: #dde1e3;
  }

    .btn-search {
        border-radius: 0rem .25rem .25rem 0rem;
      }

      .btn-reset {
        border-top-left-radius: 0.375rem;
      }

    .order-item-config {
        font-size: 1rem;
    }
    .card-header {
        background-color:  #fff;
    }

    .order-wrapper {
        border: var(--bs-card-border-width) solid var(--bs-card-border-color);
        border-radius: var(--bs-card-border-radius);

        width: 100%;
        max-height:400px;
        overflow-x:auto;
        overflow-y:scroll;
    }

     /*@media (min-width: 1400) {
        .order-wrapper {
          overflow-x: hidden;
        }
      }*/


    .order-table {
        display: flex;
        flex-flow: column nowrap;
        
        margin: 0.5rem;
        line-height: 1.5;
        
        flex: 1 1 auto;
        max-width:100%;
        
    }

     .order-table > .order-tr {
        display: flex;
        flex-wrap: nowrap;
        min-height: 53.5px;
    }

      .order-th {
        display: none;
        font-weight: 700;
        background-color: #f2f2f2;
    }

      .order-th > .order-td {
        white-space: normal;
    }

      .order-tr {
        min-width: 800px;
        display: flex;
        flex-flow: row nowrap;

    }

    

     .order-tr:nth-of-type(even) {
        background-color: #f8fafc;
    }

    .order-tr:nth-of-type(odd) {
        background-color: #ffffff;
    }

    .order-tr:hover {
        background-color: #f2f2f2;
    }

    .order-td {
        display: flex;
        flex-flow: row nowrap;
        flex-grow: 1;
        flex-basis: 0;
        padding: 0.5em;
        word-break: break-word;
        min-width: 0px;
        border-bottom: 1px solid #d0d0d0;
        align-items: center;
    }

    .order-img-col {
        min-width: 100px;
        justify-content: center;
    }

    .order-sku-col {
        min-width: 210px;
        justify-content: center;
    }

    .order-name-col {
        min-width: 210px;
        justify-content: center;
    }

    .order-price-col {
        min-width: 105px;
        justify-content: center;
    }

    .order-quantity-col {
        min-width: 70px;
        justify-content: center;
    }



    .line-item-table {
        display: flex;
        flex-flow: column nowrap;
        
        margin: 0.5rem;
        line-height: 2;
        
        flex: 1 1 auto;
        max-width:100%;
        
    }

     .line-item-table > .line-item-tr {
        display: flex;
        flex-wrap: nowrap;
        min-height: 53.5px;
    }

      .line-item-th {
        display: none;
        font-weight: 700;
        background-color: #f2f2f2;
    }

      .line-item-th > .line-item-td {
        white-space: normal;
    }

      .line-item-tr {
        /*min-width: 800px;*/
        display: flex;
        flex-flow: row nowrap;
        border-bottom: 1px solid #d0d0d0;
        padding-top: 10px;
        padding-bottom: 10px;

    }

    .line-item-tr:first-of-type {
        padding-top: 0px;
    }

    .line-item-tr:last-of-type {
        border-bottom: none;
        padding-bottom:  0px;
    }



    .line-item-tr:hover {
        background-color: #f2f2f2;
    }

    .line-item-td {
        display: flex;
        flex-flow: row nowrap;
        flex-grow: 1;
        flex-basis: 0;
        padding: 0.5em;
        word-break: break-word;
        min-width: 0px;
        
        align-items: center;
    }

    

    .line-item-img-col {
        max-width: 75px;
        min-width: 75px;
        justify-content: start;
    }

    .line-item-meta-col {
        font-weight: 500;
        min-width: 207px;
        justify-content: start;
    }

    .line-item-cost-col {
        min-width: 100px;
        justify-content: end;
    }

    .confirm-item-table {
        display: flex;
        flex-flow: column nowrap;
        
        margin: 0.5rem;
        line-height: 2.5;
        
        flex: 1 1 auto;
        max-width:100%;
        
    }

     .confirm-item-table > .confirm-item-tr {
        display: flex;
        flex-wrap: nowrap;
        min-height: 53.5px;
    }

      .confirm-item-th {
        display: none;
        font-weight: 700;
        background-color: #f2f2f2;
    }

      .confirm-item-th > .confirm-item-td {
        white-space: normal;
    }

      .confirm-item-tr {
        /*min-width: 800px;*/
        display: flex;
        flex-flow: row nowrap;
        border-bottom: 1px solid #d0d0d0;
        padding: 10px;
        /*padding-bottom: 20px;
        padding-left: 20px;
        padding-right: 20px;*/

    }

    .confirm-item-tr:first-of-type {
        padding-top: 5px;
    }

    .confirm-item-tr:last-of-type {
        border-bottom: none;
        padding-bottom:  5px;
    }



    .confirm-item-tr:hover {
        background-color: #f2f2f2;
    }

    .confirm-item-td {
        display: flex;
        flex-flow: row nowrap;
        flex-grow: 1;
        flex-basis: 0;
        padding: 0.5em;
        word-break: break-word;
        min-width: 0px;
        
        align-items: center;
    }

    

    .confirm-item-img-col {
        font-size: 1rem;
        max-width: 90px;
        min-width: 90px;
        justify-content: start;
    }

    .confirm-item-meta-col {
        font-size: 1.2rem;
        font-weight: 500;
        /*min-width: 207px;*/
        justify-content: start;
    }

    .confirm-item-cost-col {
        font-size: 1.1rem;
        font-weight: 600;
        /*min-width: 100px;*/
        justify-content: start;
    }

    .line-item-child-table {
      display: flex;
      flex-flow: column nowrap;
      font-size: 1rem;
      line-height: 1;
      flex: 1 1 auto;
    }

    .line-item-child-table > .line-item-child-tr {
      display: flex;
      flex-wrap: nowrap;
      /*min-height: 53.5px;*/
    }

    .line-item-child-td {
      display: flex;
      flex-flow: row nowrap;
      flex-grow: 1;
      flex-basis: 0;
      padding: 0.5em;
      word-break: break-word;
      min-width: 0px;
      /*justify-content: center;*/
      align-items: center;
    }


    .confirm-wrapper {


        width: 100%;
        /*min-height:265.23px;*/
        overflow:auto;
        /*overflow-y:auto;*/
        border-bottom: none;
    }

     /*@media (min-width: 1400) {
        .order-wrapper {
          overflow-x: hidden;
        }
      }*/


    .confirm-table {
        display: flex;
        flex-flow: column nowrap;
        
        margin: 0.5rem;
        line-height: 1.5;
        
        flex: 1 1 auto;
        max-width:100%;
        
    }

     .confirm-table > .confirm-tr {
        display: flex;
        flex-wrap: nowrap;
        min-height: 53.5px;
    }

      .confirm-th {
        display: none;
        font-weight: 700;
        background-color: #f2f2f2;
    }

      .confirm-th > .confirm-td {
        white-space: normal;
    }

      .confirm-tr {
        min-width: 964px;
        display: flex;
        flex-flow: row nowrap;

    }

    

    .confirm-tr:nth-of-type(even) {
        background-color: #f8fafc;
    }

    .confirm-tr:nth-of-type(odd) {
        background-color: #ffffff;
    }

    .confirm-tr:hover {
        background-color: #f2f2f2;
    }

    .confirm-td {
        display: flex;
        flex-flow: row nowrap;
        flex-grow: 1;
        flex-basis: 0;
        padding: 0.5em;
        word-break: break-word;
        min-width: 0px;
        border-bottom: 1px solid #d0d0d0;
        align-items: center;
    }

    .confirm-qty-col {
        max-width: 70px;
        justify-content: center;
    }

    .confirm-total-qty-col {
        max-width: 79px;
        justify-content: center;
    }

    .confirm-price-col {
        max-width: 100px;
        justify-content: center;
    }

    .confirm-total-price-col {
        /*background-color: #bce7ff;*/
        flex: 1 0 100px;
        max-width: 100px;
        justify-content: center;
        /*display: inline-block;*/
        position:sticky;
        right: 0;
        /*float: right;*/

    }

    .confirm-tr:nth-of-type(even) .confirm-total-price-col {
        background-color: #f8fafc;
    }

    .confirm-tr:nth-of-type(odd) .confirm-total-price-col {
        background-color: #ffffff;
    }

    .confirm-img-col {
        max-width: 60px;
        justify-content: center;
    }




</style>

<script>
// import 'qs';
const qs = require('qs');
// import qs from 'qs';

import moment from 'moment'
  export default {
   // props:['orderId','userName'],
   props:{
        orderId: {
            type: Number,
            required: false,
            // default:0
        },
        user: Object,
        contactId: {
            type: Number,
            required: false,
        },
    },
    data() {
      return {
        pagination: {
          "current_page": 1,
          "data": [],
          "first_page_url": null,
          "from": null,
          "last_page": null,
          "last_page_url": null,
          "next_page_url": null,
          "path": null,
          "prev_page_url": null,
          "to": null,
          "total": null,
          "has_more_pages": false,
          "per_page": 1000,
          "contacts": [],
          "product_filters": {
            "category": [],
            "style": [],
            "model": [],
            "size": [],
            "color": [],
          },
          "searchparams": {
            "search": "",
            "sortby": "sku",
            "order": "asc",
            "type": "",
            "style": "",
            "model": "",
            "color": "",
            "size": "",
            "in_stock_only": ""
          },
        },
        data_endpoint: "/api/orders/products",
        order_endpoint: "/api/orders/order/",
        search_params_changed: false,
        products: [],
        contacts: [],
        contact_warning: false,
        loading: false,
        fetched_products: false,
        fetched_order: false,
        selected_product: [],
        selected_contact: [],
        product_selected: false,
        min_ship_date: null,
        max_ship_date: null,
        saved: false,
        updating: false,
        refreshHack: 0,
        toggleOrderItemsEdit: false,
        toggle_contact_edit: false,
        og_contact: 0,
        new_order: {
            "contact_id": 0, 
            "order_number": "",
            "multi_ship": false,
            "contains_preorder": false,
            "sync_status": "draft",
            "discount_percent": 0,
            "total_cost": 0,
            "ship_one_date": null,
            "ship_two_date": null,
            "hubspot_status": null,
            "net_terms": null,
            "items":[]
        },
        new_item: {
            "id": null,
            "sku": null,
            "name": null,
            "image_url": null,
            "preorder": false,
            "margin_override": false,
            "unit_price": 0,
            "total_quantity": 0,
            "total_cost": 0,
            "ship_one": {
                "quantity": 0,
                "cost": 0,
                "preorder": false,
            },
            "ship_two": {
                "quantity": 0,
                "cost": 0,
                "preorder": false,
            }
        },
    };
    },
    created() {
      // runs when the component is created
      
      this.fetchData();
      this.setDefaultDates();

      if (this.contactId) { this.new_order.contact_id = this.contactId; }
    },
    mounted() {
      // runs when the element is injected into the browser
    },
    computed: {
        paymentTerms(){
            if (this.new_order.total_cost)
            {
                if (this.new_order.total_cost >= 0 && this.new_order.total_cost <= 10000)
                {
                    return 'Net 30';
                } else if (this.new_order.total_cost >= 10001 && this.new_order.total_cost <= 20000){
                    return 'Net 45';
                } else if (this.new_order.total_cost >= 20001 && this.new_order.total_cost <= 50000) {
                    return 'Net 45 + Freight 50% Off';
                } else if (this.new_order.total_cost >= 50001 && this.new_order.total_cost <= 100000) {
                    return 'Net 60 + Full Freight Free + Demo Day';
                } else {
                    return 'Net 60 + Full Freight Free + Demo Day + Custom Board';
                }
            }
        },
        shipDateTwo(){
            if (this.new_order.multi_ship && this.new_order.ship_two_date != null)
            {
                this.new_order.ship_two_date = this.new_order.ship_two_date;
            } else if (this.new_order.multi_ship && this.new_order.ship_two_date === null) {
                this.new_order.ship_two_date = moment().add(1, 'M').format("YYYY-MM-DD");
            } else {
                this.new_order.ship_two_date = null;
            
            }
        },
        maxItemQuantity(){
            if (this.selected_product.length != 0 && !this.new_item.preorder)
            {
                let available = this.selected_product.quantity_available + this.selected_product.quantity_incoming;

                return available;
            } else if (this.selected_product.length != 0 && this.new_item.preorder) {
                return null;
            } else {
                return 0;
            }
        },
        orderContact()
        {
            const result = this.contacts.find(({ id }) => id === this.new_order.contact_id);

            return result;
        },
        maxShipOneItemQuantity(){
            if (this.selected_product.length != 0 && !this.new_item.preorder)
            {
                let available = this.selected_product.quantity_available + this.selected_product.quantity_incoming;

                return available - this.new_item.ship_two.quantity;
            } else if (this.selected_product.length != 0 && this.new_item.preorder) {
                return null;
            } else {
                return 0;
            }
        },
        maxShipTwoItemQuantity(){
            if (this.selected_product.length != 0 && !this.new_item.preorder)
            {
                let available = this.selected_product.quantity_available + this.selected_product.quantity_incoming;

                return available - this.new_item.ship_one.quantity;
            } else if (this.selected_product.length != 0 && this.new_item.preorder) {
                return null;
            } else {
                return 0;
            }
        },
        newItemTotals(){
                
                this.new_item.ship_one.cost = this.new_item.ship_one.quantity * this.new_item.unit_price;
                this.new_item.ship_two.cost = this.new_item.ship_two.quantity * this.new_item.unit_price;
                this.new_item.total_quantity = +this.new_item.ship_one.quantity + +this.new_item.ship_two.quantity;
                this.new_item.total_cost = (this.new_item.ship_one.quantity * this.new_item.unit_price) + (this.new_item.ship_two.quantity * this.new_item.unit_price);
                this.refreshHack;
                if (this.selected_product.quantity_available == 0 && this.selected_product.quantity_incoming > 0)
                {
                    this.new_item.preorder = true;
                }
                


            if (this.new_order.items.length != 0)
            {
                let total = 0;
                this.new_order.items.forEach((item) => {
                    total = +item.total_cost + total;
                });

                this.new_order.total_cost = total;
            }
        },
        todaysDate(){
            return moment().format('MMMM Do, YYYY');
        },
        newItemTotalQuantity(){
            return +this.new_item.ship_one.quantity + +this.new_item.ship_two.quantity;
        },
        newOrderTotalCost(){
            let total = 0;

            this.new_order.items.forEach((item) => {
                total = +item.total_cost + total;
            });

            return total;
        },
        retailDenominator(){
            if (this.new_order.discount_percent != 0)
            {
                return (100 - this.new_order.discount_percent) / 100;
            } else {
                return 0.55;
            }
        },
        retailTotalCost(){
            let retailTotal = 0;
                this.new_order.items.forEach((item) => {

                    retailTotal = ((+item.ship_one.quantity + +item.ship_two.quantity) * +item.retail_price) + retailTotal;
                });

                return retailTotal;
        }
        // shipTwoMaxItemQuantity(){
        //     if (this.selected_product.length != 0)
        //     {
        // }

    },
    methods: {
        edit_contact(id){
            this.og_contact = id;
            this.toggle_contact_edit = true;
        },
        cancel_contact_edit() {
            this.new_order.contact_id = this.og_contact;
            this.toggle_contact_edit = false;
            this.og_contact = 0;
        },
        togglePreorder(item){

            this.new_item.preorder = !this.new_item.preorder;

            if(!this.new_item.preorder)
            {
                if ((+this.new_item.ship_one.quantity + +this.new_item.ship_two.quantity) > (+this.selected_product.quantity_available + +this.selected_product.quantity_incoming))
                {
                    this.new_item.ship_one.quantity = +this.selected_product.quantity_available + +this.selected_product.quantity_incoming;
                    this.new_item.ship_two.quantity = 0;
                }
                
            }
            //     this.maxShipOneItemQuantity = null;
            //     this.maxShipTwoItemQuantity = null;
            // } 
            // else {
                // if ((this.orderEdit.items[objIndex].ship_one.quantity + this.orderEdit.items[objIndex].ship_two.quantity) > this.product.quantity_orderable)
                // {
                //     this.orderEdit.items[objIndex].ship_one.quantity = this.orderEdit.items[objIndex].quantities.quantity_orderable;

                //     this.orderEdit.items[objIndex].ship_two.quantity = this.orderEdit.items[objIndex].quantities.quantity_orderable - this.orderEdit.items[objIndex].ship_one.quantity;
                //     this.orderEdit.items[objIndex].total_quantity = +this.orderEdit.items[objIndex].ship_one.quantity + +this.orderEdit.items[objIndex].ship_two.quantity;
                // }

                // // if (this.orderEdit.items[objIndex].ship_two.quantity > (this.orderEdit.items[objIndex].quantities.quantity_orderable + this.orderEdit.items[objIndex].ship_one.quantity))
                // // {
                    
                // // }

                // this.orderEdit.items[objIndex].ship_one.max_orderable_quantity = this.orderEdit.items[objIndex].quantities.quantity_orderable - this.orderEdit.items[objIndex].ship_two.quantity;
                // this.orderEdit.items[objIndex].ship_two.max_orderable_quantity = this.orderEdit.items[objIndex].quantities.quantity_orderable - this.orderEdit.items[objIndex].ship_one.quantity;


            // }
        },
        toggleSplitShipments(){
            this.new_order.multi_ship = !this.new_order.multi_ship;

            if (!this.new_order.multi_ship)
            {
                this.new_item.ship_two.quantity = 0;
                this.new_item.ship_two.cost = 0;
                this.new_item.ship_two.preorder = false;
            }
        },
        addItemToOrder(){

            const line_item = structuredClone(this.new_item);

            if (line_item.preorder == true)
            {
                this.new_order.contains_preorder = true;
            }

            this.new_order.items.push(line_item);

            this.product_selected = false;
            this.selected_product = [];

            this.new_item.id = null;
            this.new_item.sku = null;
            this.new_item.name = null;
            this.new_item.image_url = null;
            this.new_item.unit_price = 0;
            this.new_item.total_cost = 0;
            this.new_item.preorder = false;
            this.new_item.ship_one.quantity = 0;
            this.new_item.ship_one.cost = 0;
            this.new_item.ship_one.preorder = false;
            this.new_item.ship_two.quantity = 0;
            this.new_item.ship_two.cost = 0;
            this.new_item.ship_two.preorder = false;
            this.new_item.margin_override = false;
           

        },
        cancelOrderItem(){
            this.product_selected = false;
            this.selected_product = [];
            this.resetOrderItem();
        },
        resetOrderItem(){
            this.new_item.id = null;
            this.new_item.sku = null;
            this.new_item.name = null;
            this.new_item.image_url = null;
            this.new_item.unit_price = 0;
            this.new_item.total_cost = 0;
            this.new_item.preorder = false;
            this.new_item.ship_one.quantity = 0;
            this.new_item.ship_one.cost = 0;
            this.new_item.ship_two.preorder = false;
            this.new_item.ship_two.quantity = 0;
            this.new_item.ship_two.cost = 0;
            this.new_item.ship_two.preorder = false;
            this.new_item.margin_override = false;

        },
        setDefaultDates(){

            if (!this.orderId)
            {
                this.new_order.ship_one_date = moment().add(1, 'd').format("YYYY-MM-DD");
                this.new_order.ship_two_date = null;
            }
                this.min_ship_date = moment().add(1, 'd').format("YYYY-MM-DD");
                this.max_ship_date = moment().add(1, 'Y').format("YYYY-MM-DD");
            
            
        },
      fetchData(){
        if (this.orderId)
        {
            this.fetchOrder();
        }

        if (this.new_order.sync_status === 'draft')
        {
            this.fetchProducts(this.pagination.searchparams);
        }
      },
      fetchOrder() {
        this.loading = true;
        axios.get(this.order_endpoint + this.orderId)
        .then((res) => {
            this.new_order = res.data;

            // this.products = res.data.data;
            // this.contacts = res.data.contacts;
          }).catch((error) => {
            console.log(error.response.data);
          }).finally(() => {
            this.fetched_order = true;
            this.loading = false;
            this.saved = true;
            return true;
          });
      },
      fetchProducts(params, page = 1) {
        this.loading = true;
        params.page = page;
        params.per_page = this.pagination.per_page;
        axios.get(this.data_endpoint, {
                params: params,
                paramsSerializer: function(params) {
                    return qs.stringify(params)
                },

          }).then((res) => {
            this.pagination = res.data;
            this.products = res.data.data;
            this.contacts = res.data.contacts;
            this.product_filters = res.data.product_filters;
          }).catch((error) => {
            console.log(error.response.data);
          }).finally(() => {
            this.fetched_products = true;
            this.loading = false;
            return true;
          });
      },
      fetchCompanies() {
        let params = this.pagination.searchparams;

        axios.get(this.data_endpoint, {
            paramsSerializer: function(params) {
                return qs.stringify(params)
            },

          }).then((res) => {
            this.contacts = res.data.contacts;
          }).catch((error) => {
            console.log(error.response.data);
          }).finally(() => {
            return true;
          });
      },
      nextPage(){
        this.fetchProducts(this.pagination.searchparams, this.pagination.current_page + 1);
      },
      prevPage(){
        this.fetchProducts(this.pagination.searchparams, this.pagination.current_page - 1);
      },
      firstPage(){
        this.fetchProducts(this.pagination.searchparams, 1);
      },
      lastPage(){
        this.fetchProducts(this.pagination.searchparams, this.pagination.last_page);
      },
      runSearch() {
        this.fetchProducts(this.pagination.searchparams);
        this.search_params_changed = false;
      },
      setActiveProduct(product) {

            // if (product.quantity_orderable != 0)
            // {
            //     this.new_item.preorder = true;
            // }
                if (this.selected_product.length != 0)
                {
                    this.resetOrderItem();
                }

                this.selected_product = product;
                this.product_selected = true;
                this.new_item.id = product.id;
                this.new_item.sku = product.sku;
                this.new_item.image_url = product.image_url;
                this.new_item.name = product.name;
                this.new_item.unit_price = product.sale_price;
                this.refreshHack++;
            
        },
        resetSearch()
        {
            this.pagination.first_page_url = null;
          this.pagination.from = null;
          this.pagination.last_page = null;
          this.pagination.last_page_url = null;
          this.pagination.next_page_url = null;
          this.pagination.path = null;
          this.pagination.prev_page_url = null;
          this.pagination.to = null;
          this.pagination.total = null;
          this.pagination.has_more_pages = false;
          this.pagination.per_page = 1000;
      
            this.pagination.searchparams.search = '';
            this.pagination.searchparams.sortby = 'sku';
            this.pagination.searchparams.order = 'asc';
            this.pagination.searchparams.type = '';
            this.pagination.searchparams.style = '';
            this.pagination.searchparams.model = '';
            this.pagination.searchparams.color = '';
            this.pagination.searchparams.size = '';
            this.pagination.searchparams.in_stock_only = '';
        
            this.runSearch();
        },
        saveDraft(){

            if (this.new_order.contact_id != 0)
            {

                if (!this.saved)
                {
                    this.saveOrder();
                } else {
                    this.new_order.hubspot_status = 'Update Queued';
                    this.updateOrder();
                }
            } else {
                this.contact_warning = true;
            }
        },
        setStatus(status)
        {
            this.new_order.sync_status = status;
        },
        continueOrder(){
            if (this.new_order.contact_id != 0)
            {
                if (this.new_order.sync_status === 'draft')
                {
                    this.new_order.sync_status = 'draft_review';
                } else {
                    this.new_order.sync_status = 'draft_confirm';
                }
                
                this.saveDraft();
            } else {
                this.contact_warning = true;
            }
        },
        placeOrder(){

            let close_time = moment().format();
            this.new_order.hubspot_status = 'Won Queued';
            this.new_order.shipstation_status = 'Creation Queued';
            this.new_order.sync_status = 'Queued';
            this.new_order.closed_at = close_time;
            // console.log(this.new_order.closed_at);
            this.updateOrder();
            window.location.href = '/orders';
          
        },
        saveOrder(){
            axios({
              method: 'post',
              url: '/api/orders/order',
              data: this.new_order,
            }).then((res)=>{
                this.saved = true;
                // this.new_order = res.data;
                window.location.href = '/order/' + res.data.id;
                // Bus.$emit('newOacAlert', {text: 'Thank you for requesting a new feature!', type: 'success'});
            }).catch((error) => {
              console.log(error);
              // this.errors.push({msg: error.response.data.message });
              // Bus.$emit('newOacAlert', {text: error.response.data.message, type: 'danger'});
            });
        },
        updateOrder(){
            this.updating = true;
            axios({
              method: 'put',
              url: '/api/orders/order/' + this.orderId,
              data: this.new_order,
            }).then((res)=>{
                this.updating = false;
                this.saved = true;
                this.new_order = res.data;
                // Bus.$emit('newOacAlert', {text: 'Thank you for requesting a new feature!', type: 'success'});
            }).catch((error) => {
              console.log(error);
              // this.errors.push({msg: error.response.data.message });
              // Bus.$emit('newOacAlert', {text: error.response.data.message, type: 'danger'});
            });
        },
        editOrderItems(new_order) {
            this.$forceUpdate();
            setTimeout(this.showEditOrderItemModal, 250);
        },
        showEditOrderItemModal() {
            Bus.$emit('editOrderItemModalShow');
        },
        sendQuote() {
            this.saveDraft();
            setTimeout(this.showSendQuoteModal, 250);
        },
        showSendQuoteModal() {
            Bus.$emit('sendQuoteModalShow');
        },
        // editCustomerModal() {
        //     this.selected_company = this.orderContact;
        //     setTimeout(this.showEditCustomerModal, 250);
        // },
        showEditCustomerModal() {
            Bus.$emit('editCustomerModalShow');
        },
    },
    filters: {
        moment: function (date) {
            return moment(date).format('MMM Do, YYYY');
        }
    },
    watch: {
      search_params_changed: function (newItem, oldItem) {
        this.runSearch();
      },
      new_order: function (newItem, oldItem) {
        if (this.new_order.contact_id != 0)
        {
            this.contact_warning = false;
        }
      },
      newItemTotalQuantity: function (val) {
        this.new_item.total_cost = val * this.new_item.unit_price;
        this.new_item.total_quantity = val;
      },
      newOrderTotalCost: function (val) {
        this.new_order.total_cost = val;
      }
      // selected_product: function (newItem, oldItem) {
      //   this.resetOrderItem();
      // },
    }
  }

</script>
